export default [
  {
    clientName: "John Doe",
    phone: "9892835752",
    emailid: "abc@gmail.com",
    articlesent: "46",
    articleread: "60",
    totaltimespend: "14:42:09",
    articleforwarded: "27",
    likes: "20",
    comments: "52",
    channels: "Channel, D1,",
    dateadded: "20/05/2020, 16:15:33"
  },
  {
    clientName: "John Doe",
    phone: "9892835752",
    emailid: "abc@gmail.com",
    articlesent: "46",
    articleread: "60",
    totaltimespend: "14:42:09",
    articleforwarded: "27",
    likes: "20",
    comments: "52",
    channels: "Channel, D1,",
    dateadded: "20/05/2020, 16:15:33"
  },
  {
    clientName: "John Doe",
    phone: "9892835752",
    emailid: "abc@gmail.com",
    articlesent: "46",
    articleread: "60",
    totaltimespend: "14:42:09",
    articleforwarded: "27",
    likes: "20",
    comments: "52",
    channels: "Channel, D1,",
    dateadded: "20/05/2020, 16:15:33"
  },
  {
    clientName: "John Doe",
    phone: "9892835752",
    emailid: "abc@gmail.com",
    articlesent: "46",
    articleread: "60",
    totaltimespend: "14:42:09",
    articleforwarded: "27",
    likes: "20",
    comments: "52",
    channels: "Channel, D1,",
    dateadded: "20/05/2020, 16:15:33"
  },
  {
    clientName: "John Doe",
    phone: "9892835752",
    emailid: "abc@gmail.com",
    articlesent: "46",
    articleread: "60",
    totaltimespend: "14:42:09",
    articleforwarded: "27",
    likes: "20",
    comments: "52",
    channels: "Channel, D1,",
    dateadded: "20/05/2020, 16:15:33"
  }
];
